<template>
    <div class="index">
        <Header @show-contact="showContact" :active="0"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner-pc" src="../assets/image/banner/banner_index.png"></img>
            <img class="banner-m" src="../assets/image/banner/banner_index_m.jpg"></img>
        </div>
        <!-- 公司简介 -->
        <div class="container-index" id="container">
            <img src="../assets/image/index/compony.jpg">
            <p class="container-title">关于慧建智联</p>
            <div class="content">
                <p>杭州慧建智联科技有限公司</p>
                <img src="../assets/image/icon/icon_firm.png">
                <span>
                    杭州慧建智联科技有限公司成立于2021年，总部位于杭州，同时设有两个研发中心和一个技术支持中心。<br>慧建智联致力于拓展现实+人工智能研发，结合智能传感器、物联网、空间智能、边缘计算等先进技术自主研发国产化工业级XR智能硬件产品及解决方案。凭借丰富的智能领域服务经验和技术积累，慧建智联自主研发的荟镜XR头显设备具有清晰度高、视野广阔、延时低、无眩光的视觉效果，致力于成为工业级XR领域全球领先的标杆产品。
                </span>
            </div>
        </div>
        <h1 class="title-m">关于慧建智联</h1>
        <div class="info-m" id="team">
            <div class="top">
                <p>
                    <img src="../assets/image/icon/icon_firms_m.png" align="left">
                    杭州慧建智联科技有限公司成立于2021年，总部位于杭州，同时设有两个研发中心和一个技术支持中心。慧建智联致力于拓展现实+人工智能研发，结合智能传感器、物联网、空间智能、边缘计算等先进技术自主研发国产化工业级XR智能硬件产品及解决方案。凭借丰富的智能领域服务经验和技术积累，慧建智联自主研发的荟镜XR头显设备具有清晰度高、视野广阔、延时低、无眩光的视觉效果，致力于成为工业级XR领域全球领先的标杆产品。
                </p>
            </div>
        </div>
        <!-- 产品介绍 -->
        <div class="product-index" id="product">
            <p class="product-title">产品介绍</p>
            <div class="product-xr">
                <div class="product-xr-left">
                    <p class="product-xr-text">XR1定焦安全版 混合现实头戴显示设备</p>
                    <p>· 高PPD</p>
                    <p>· 低延时</p>
                    <p>· 大视场角</p>
                    <button class="product-xr-button" @click="goToJump(1)">了解更多</button>
                </div>
                <div class="product-xr-right">
                    <p class="product-xr-text">XR2定焦安全版 混合现实头戴显示设备</p>
                    <p>· 高分辨率</p>
                    <p>· 低时延</p>
                    <p>· 全国产自主可控</p>
                    <button class="product-xr-button" @click="goToJump(2)">了解更多</button>
                </div>
            </div>
            <div class="product-vr">
                <div class="product-vr-left">
                    <p class="product-vr-text">VR1基础安全版 虚拟现实头戴显示设备</p>
                    <p>· 高分辨率</p>
                    <p>· 三种刷新率模式</p>
                    <p>· 大视场角</p>
                    <button class="product-vr-button" @click="goToJump(3)">了解更多</button>
                </div>
                <div class="product-vr-right">
                    <p class="product-vr-text">VR2卓越安全版 虚拟现实头戴显示设备</p>
                    <p>· 高分辨率</p>
                    <p>· 大视场角</p>
                    <p>· 全国产自主可控</p>
                    <button class="product-vr-button" @click="goToJump(4)">了解更多</button>
                </div>
            </div>
        </div>
        <div class="product-m">
            <p class="product-title">产品介绍</p>
            <img @click="goToJump(1)" src="../assets/image/index/product-xr1-m.jpg">
            <img @click="goToJump(2)" src="../assets/image/index/product-xr2-m.jpg">
            <img @click="goToJump(3)" src="../assets/image/index/product-vr1-m.jpg">
            <img @click="goToJump(4)" src="../assets/image/index/product-vr2-m.jpg">
        </div>
        <!-- 解决方案 -->
        <div class="solution-index" id="solution">
            <p class="solution-title">解决方案</p>
            <div class="solution-detail">
                <div class="item-index" @click="goToSolution(1)">
                    <img class="bg" src="../assets/image/index/solution-aviation.jpg">
                    <h2 class="title">飞行</h2>
                    <img class="item-img" src="../assets/image/icon/icon_arrow.png">
                </div>
                <div class="item-index" @click="goToSolution(2)">
                    <img class="bg" src="../assets/image/index/solution-training.jpg">
                    <h2 class="title">军体</h2>
                    <img class="item-img" src="../assets/image/icon/icon_arrow.png">
                </div>
                <div class="item-index" @click="goToSolution(3)">
                    <img class="bg" src="../assets/image/index/solution-building.jpg">
                    <h2 class="title">工业</h2>
                    <img class="item-img" src="../assets/image/icon/icon_arrow.png">
                </div>
                <div class="item-index" @click="goToSolution(4)">
                    <img class="bg" src="../assets/image/index/solution-aviation.jpg">
                    <h2 class="title">低空</h2>
                    <img class="item-img" src="../assets/image/icon/icon_arrow.png">
                </div>
            </div>
            <div class="solution-detail-m">
                <div class="item-m" @click="goToSolution(1)">
                    <img class="bg" src="../assets/image/index/solution-aviation.jpg">
                    <h2 class="title">飞行</h2>
                </div>
                <div class="item-m" @click="goToSolution(2)">
                    <img class="bg" src="../assets/image/index/solution-training.jpg">
                    <h2 class="title">军体</h2>
                </div>
                <div class="item-m" @click="goToSolution(3)">
                    <img class="bg" src="../assets/image/index/solution-building.jpg">
                    <h2 class="title">工业</h2>
                </div>
                <div class="item-m" @click="goToSolution(4)">
                    <img class="bg" src="../assets/image/index/solution-aviation.jpg">
                    <h2 class="title">低空</h2>
                </div>
            </div>
        </div>
        <!-- 合作方案 -->
        <!-- <div class="partner-index" id="partner">
            <p class="partner-title">合作伙伴</p>
            <img class="partner-pc" src="../assets/image/index/partner-pc.jpg">
            <img class="partner-m" src="../assets/image/index/partner-m.jpg">
        </div> -->
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import { baseUrl } from '../api/images';
import { uploadeImage } from '../api/images'
import Footer from '../components/Footer.vue'
import Header from '../components/Head.vue'
import Contact from '../components/Contact.vue'
import Email from '../components/Email.vue'
export default {
    data() {
        return {
            uploadeImage: uploadeImage,
            isFixed: false,
            logo: baseUrl + 'logo.png',
            menu: baseUrl + 'menu.png',
            isContactVisible: false
        };
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        goAbout() {
            this.$router.push({ name: 'About' });
        },
        goProduct() {
            this.$router.push({ name: 'Product' });
        },
        goToJump(num) {
            switch (num) {
                case 1:
                    window.location.href = '/#/products/XR1';
                    break;
                case 2:
                    window.location.href = '/#/products/XR2'
                    break;
                case 3:
                    window.location.href = '/#/products/VR1'
                    break;
                case 4:
                    window.location.href = '/#/products/VR2'
                    break;
            }
        },
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        },
        goToSolution(num) {
            switch (num) {
                case 1:
                    window.location.href = '/#/solutions/aviation';
                    break;
                case 2:
                    window.location.href = '/#/solutions/training'
                    break;
                case 3:
                    window.location.href = '/#/solutions/industry'
                    break;
                case 4:
                    window.location.href = '/#/solutions/lowAltitude'
                    break;
            }
        }
        
    },
};
</script>

<style scoped>
    @import '../assets/css/indexStyle.css';
</style>